import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitTriggerModel } from '@apps-common/types/portal/unit-trigger'

export const QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGER = (triggerId?: number) => ['getMyMonitoringUnitTrigger', triggerId].filter(Boolean)

const getUnitTrigger = async (triggerId?: number): Promise<IUnitTriggerModel> =>
  axios.get(`/my-monitoring/sites/GetTrigger?triggerId=${triggerId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitTrigger

type Props = {
  config?: QueryConfig<QueryFnType>
  triggerId: number
}

export const useMyMonitoringGetUnitTrigger = ({ config, triggerId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGER(triggerId),
    queryFn: () => getUnitTrigger(triggerId)
  })
